// src/api/getTodayCandles.js
import axios from "axios";

/**
 * Get today's candlestick data from Delta Exchange
 * @param {string} symbol - e.g., "BTCUSD"
 * @param {string} resolution - e.g., "5m", "1h"
 * @returns {Promise<Object>} - API response
 */
export const getTodayCandles = async (symbol = "BTCUSD", resolution = "1m",daydata=7) => {
  try {
    // IF resolution 1m , 5m, 15m then show today data otherwise shoow last 2 days data
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0); // Set to start of today in UTC
    const startOfToday = Math.floor(today.getTime() / 1000); // Convert
    // to seconds since epoch
    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const start =
      resolution === "1m" 
        ? startOfToday
        : startOfToday - daydata * 24 * 60 * 60; // Last 7 days in seconds

   

    const url = `https://api.india.delta.exchange/v2/history/candles?resolution=${resolution}&symbol=${symbol}&start=${start}&end=${now}`;

    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching candle data:", error);
    throw error;
  }
};
